export const ADMIN_ROUTES = {
  // Auth routes
  root: "/admin",
  login: "/admin/login",
  forgotPassword: "/admin/forgot-password",
  resetPassword: "/admin/reset-password",
  changePassword: "/admin/change-password",

  // Dashboard routes
  dashboard: "/admin/dashboard",

  // Admin Management
  admins: "/admin/admins",
  adminDetail: "/admin/admins/:id",
  createAdmin: "/admin/admins/create",
  editAdmin: "/admin/admins/edit/:id",

  // User Management
  users: "/admin/users",
  userDetail: "/admin/users/:id",

  // Room Management
  rooms: "/admin/rooms",
  roomDetail: "/admin/rooms/:id",

  // Session Management
  sessions: "/admin/sessions",

  // Payment Management
  payments: "/admin/payments",
  paymentDetail: "/admin/payments/:id",

  // Analytics
  analytics: "/admin/analytics",

  // Advertisements
  ads: "/admin/ads",
  adDetail: "/admin/ads/:id",

  // Platform Economy
  economy: "/admin/economy",

  // Activity Logs
  logs: "/admin/logs",
  logDetail: "/admin/logs/:id",

  // Reports
  reports: "/admin/reports",

  // Notifications
  notifications: "/admin/notifications",

  // Settings
  settings: "/admin/settings",
  profile: "/admin/profile",
};
